<template>
	<div id="main" class="column is-9">
		<section class="all-psychics">
			<div class="columns">
				<div class="column">
					<router-link to="/Newpsychic" class="button is-link add-psychic is-small"><i class="fa fa-plus"></i>&nbsp;Psychic</router-link>
					<h1>All Psychics</h1>
				</div>
			</div>
			<div class="column">
				<div class="columns refine" v-if="!searched">
					<DatePicker 
						:startDate="startDate" 
						:endDate="endDate"
						@startDateInput="updateStartDate"
						@endDateInput="updateEndDate"
						@enter="updateData" />
					<div class="column is-7">
						<div class="columns refine is-mobile">
							<div class="column">
								<div class="field">
									<div class="control">
										<a class="button is-primary is-small" @click="updateData">
										Update </a>
									</div>
								</div>
							</div>
							<div class="column">
								<PageSize v-model="pageSize" @input="$refs.paginator.goToPage(0)" />
							</div>
						</div>
					</div>
				</div>
				<div class="columns refine">
					<div class="column is-5">
						<div class="field is-maxed">
							<div class="control is-expanded">
								<input class="input is-small" type="text" placeholder="Username, Name, or Extension" v-model="searchTerm"/>
							</div>
						</div>
					</div>
					<div class="column is-4">
						<div class="columns refine is-mobile">
							<div class="column">
								<div class="field">
									<div class="control">
										<a class="button is-primary is-small" @click="search">
										Search </a>
									</div>
								</div>
							</div>
							<div class="column" v-if="searched">
								<div class="field">
									<div class="control">
										<a class="button is-primary is-small" @click="searched = false">
										Clear </a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Spinner size="large" v-if="!idle"></Spinner>
			<div class="card-table" v-if="idle">
				<div class="table-container">
					<table id="allPsychics" class="table is-striped is-fullwidth" v-if="searched">
						<thead>
							<tr>
								<th>
									Agent
								</th>
								<th>
									Last Name
								</th>
								<th>
									First Name
								</th>
								<th>
									Extension
								</th>
								<th>
									Status
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="psychic in searchResults" :key="psychic.user_id">
								<td class="member-name">
									<router-link :to="'/psychics/' + psychic.user_id">{{ psychic.username }}</router-link>
								</td>
								<td>{{ psychic.last_name }}</td>
								<td>{{ psychic.first_name }}</td>
								<td>{{ psychic.extension }}</td>
								<td>{{ psychic.account_status }}</td>
							</tr>
						</tbody>
					</table>
					<table id="allPsychics" class="table is-striped is-fullwidth" v-if="!searched">
						<thead>
							<tr>
								<th>
									Agent
								</th>
								<th class="is-hidden-mobile">
									<a v-on:click="sortBy('last_name')">Last Nm.</a>
								</th>
								<th class="is-hidden-mobile">
									<a v-on:click="sortBy('first_name')">First Nm.</a>
								</th>
								<th>
									<a v-on:click="sortBy('phone_extension')">Ext.</a>
								</th>
								<th class="is-hidden-mobile">
									<a v-on:click="sortBy('total_mins')">Tot. Min.</a>
								</th>
								<th class="is-hidden-mobile">
									<a v-on:click="sortBy('rep_mins')">Rep. Min.</a>
								</th>
								<th class="is-hidden-mobile">
									<a v-on:click="sortBy('total_calls')">Tot. Calls</a>
								</th>
								<th class="is-hidden-mobile">
									<a v-on:click="sortBy('rep_calls')">Rep. Calls</a>
								</th>
								<th class="is-hidden-mobile">
									<a v-on:click="sortBy('missed_calls')">Miss. Calls</a>
								</th>
								<th class="is-hidden-mobile">
									<a v-on:click="sortBy('rep_call_pct')">% Rep.</a>
								</th>
								<th class="is-hidden-mobile">
									<a v-on:click="sortBy('alc')">ALC</a>
								</th>
								<th class="is-hidden-mobile">
									<a v-on:click="sortBy('date')">Signup Date</a>
								</th>
								<th class="is-hidden-mobile">
									<a v-on:click="sortBy('status')">Status</a>
								</th>
								<th class="is-hidden-mobile">
									<a v-on:click="sortBy('ranking')">Rnk</a>
								</th>
								<th class="is-hidden-mobile">
									<a v-on:click="sortBy('free_minutes')">Free Min.</a>
								</th>
								<th class="is-hidden-desktop">
									&nbsp;
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="psychic in paginatedData" :key="psychic.id">
								<td>
									<router-link :to="'/psychics/' + psychic.agent_user_id">{{ psychic.user_name }}</router-link>
								</td>
								<td class="is-hidden-mobile">{{ psychic.last_name }}</td>
								<td class="is-hidden-mobile">{{ psychic.first_name }}</td>
								<td>{{ psychic.phone_extension }}</td>
								<td class="is-hidden-mobile">{{ psychic.total_mins }}</td>
								<td class="is-hidden-mobile">{{ psychic.rep_mins }}</td>
								<td class="is-hidden-mobile">{{ psychic.total_calls }}</td>
								<td class="is-hidden-mobile">{{ psychic.rep_calls }}</td>
								<td class="is-hidden-mobile">{{ psychic.missed_calls }}</td>
								<td class="is-hidden-mobile">{{ psychic.rep_call_pct }}</td>
								<td class="is-hidden-mobile">{{ psychic.alc }}</td>
								<td class="is-hidden-mobile">{{ formatDate(psychic.date) }}</td>
								<td class="is-hidden-mobile">{{ psychic.status }}</td>
								<td class="is-hidden-mobile">{{ psychic.ranking }}</td>
								<td class="is-hidden-mobile">{{ psychic.free_minutes }}</td>
								<td class="is-hidden-desktop">
									<button class="button is-info is-small" @click="selectedPsychic = psychic"><i class="fa fa-eye"></i></button>
								</td>	
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<Paginator ref="paginator" :itemCount="this.psychics.length" :pageSize="this.pageSize" v-model="pageNumber" />
			<Modal v-if="selectedPsychic" @close="selectedPsychic = null">
				<p class="modal-card-title" slot="title">
					{{ selectedPsychic.user_name }}
				</p>
				<ul slot="body">
					<li><span class="an-list-title">Last Name:</span><span class="an-list-item">{{ selectedPsychic.last_name }}</span></li>
					<li><span class="an-list-title">First Name:</span><span class="an-list-item">{{ selectedPsychic.first_name }}</span></li>
					<li><span class="an-list-title">Extension:</span><span class="an-list-item">{{ selectedPsychic.phone_extension }}</span></li>
					<li><span class="an-list-title">Total Minutes:</span><span class="an-list-item">{{ selectedPsychic.total_mins }}</span></li>
					<li><span class="an-list-title">Repeat Minutes:</span><span class="an-list-item">{{ selectedPsychic.rep_mins }}</span></li>
					<li><span class="an-list-title">Total Calls:</span><span class="an-list-item">{{ selectedPsychic.total_calls }}</span></li>
					<li><span class="an-list-title">Repeat Calls:</span><span class="an-list-item">{{ selectedPsychic.rep_calls }}</span></li>
					<li><span class="an-list-title">Missed Calls:</span><span class="an-list-item">{{ selectedPsychic.missed_calls }}</span></li>
					<li><span class="an-list-title">% Repeat:</span><span class="an-list-item">{{ selectedPsychic.rep_call_pct }}</span></li>
					<li><span class="an-list-title">ALC:</span><span class="an-list-item">{{ selectedPsychic.alc }}</span></li>
					<li><span class="an-list-title">Signup Date:</span><span class="an-list-item">{{ formatDate(selectedPsychic.date) }}</span></li>
					<li><span class="an-list-title">Status:</span><span class="an-list-item">{{ selectedPsychic.status }}</span></li>
					<li><span class="an-list-title">Rank:</span><span class="an-list-item">{{ selectedPsychic.ranking }}</span></li>
					<li><span class="an-list-title">Free Minutes:</span><span class="an-list-item">{{ selectedPsychic.free_minutes }}</span></li>
				</ul>
			</Modal>
		</section>
	</div>
</template>

<script>
import Paginator from "./Paginator.vue"
import PageSize from "./PageSize.vue"
import DatePicker from "./DatePicker.vue"
import moment from "moment-timezone"
import Modal from "./Modal.vue"
import Spinner from 'vue-simple-spinner'

export default {
	components: {
		DatePicker,
		PageSize,
		Paginator,
		Modal,
		Spinner
	},
	data() {
		return {
			searched: false,
			searchResults: [],
			searchTerm: "",
			selectedPsychic: null,
			pageNumber: 0,
			pageSize: 20,
			sortCol: '',
			sortDir: 0,
			psychics: [],
			startDate: Date.now().toString(),
			endDate: Date.now().toString(),
			idle: false
		}
	},
	methods: {
		async search() {
			this.searched = true
			this.idle = false
			this.searchResults = await this.$root.$data.getters.getPsychicSearch(this.$root.$data.state, this.searchTerm)
			this.idle = true
		},
		formatDate(date) {
			return moment.tz(date, moment.tz.guess(true)).format("MM/DD/YYYY")
		},
		sortBy(col) {
			if (this.sortCol !== col) {
				this.sortCol = col
				this.sortDir = 0
			} else {
				this.sortDir = this.sortDir === 0 ? 1 : 0
			}
		},
		sort(a, b) {
			const vA = (typeof a === 'string') ? a.toUpperCase() : a
			const vB = (typeof b === 'string') ? b.toUpperCase() : b
			let cmp = 0

			if (vA > vB) { cmp = 1}
			else if (vA < vB) { cmp = -1}
			
			return this.sortDir === 1 ? cmp * -1 : cmp
		},
		updateStartDate(date) {
			this.startDate = moment(date).valueOf().toString()
		},
		updateEndDate(date) {
			this.endDate = moment(date).valueOf().toString()
		},
		async updateData() {
			this.searched = false
			this.idle = false
			this.psychics = await this.$root.$data.getters.getPsychics(this.$root.$data.state, this.startDate, this.endDate)
			this.idle = true
		},
	},
	computed: {
		paginatedData() {
			const start = this.pageNumber * this.pageSize,
				end = start + this.pageSize

			let data = this.psychics

			if (this.sortCol !== '') {
				data = data.sort((a, b) => this.sort(a[this.sortCol], b[this.sortCol]))
			} 

			return data.slice(start, end)
		}
	},
	async mounted() {
		this.psychics = await this.$root.$data.getters.getPsychics(this.$root.$data.state)
		this.idle = true
	}
}
</script>